module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.fields), function(field) {
    return _c('v-layout', {
      key: field.key,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "lg4": ""
      }
    }, [_c('v-subheader', [_vm._v(_vm._s(field.header))])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "lg8": ""
      }
    }, [(field.type === Boolean) ? _c('v-switch', {
      attrs: {
        "label": _vm.formData[field.key] ? 'Activated' : 'Deactivated',
        "false-value": false,
        "true-value": true
      },
      model: {
        value: (_vm.formData[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.key, $$v)
        },
        expression: "formData[field.key]"
      }
    }) : (field.type === String) ? _c('v-text-field', {
      attrs: {
        "label": field.label,
        "hint": field.hint,
        "suffix": field.suffix
      },
      on: {
        "change": function($event) {
          return _vm.emitChanged()
        }
      },
      model: {
        value: (_vm.formData[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.key, $$v)
        },
        expression: "formData[field.key]"
      }
    }) : (field.type === 'Select') ? _c('v-select', {
      attrs: {
        "label": field.label,
        "items": ['Daily', 'Weekly', 'Monthly']
      },
      model: {
        value: (_vm.formData[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.key, $$v)
        },
        expression: "formData[field.key]"
      }
    }) : (field.type === 'Select-Multiple') ? _c('v-select', {
      attrs: {
        "label": field.label,
        "items": _vm.retrunReasonsList,
        "multiple": ""
      },
      model: {
        value: (_vm.formData[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.key, $$v)
        },
        expression: "formData[field.key]"
      }
    }) : _vm._e()], 1)], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-b62f0642"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsSettingsDialog.vue
// module id = 950
// module chunks = 1